import "datatables.net";
import "../components/hs-datatables";
import "flatpickr";
import "../components/hs-range-datepicker";
import "../components/hs-selectpicker";
import "../components/hs-chart-pie";
import "../components/hs-progress-bar";

export default {
  init() {

  },
  finalize() {
   
    $( window ).load(function() {
        if (window.location.href.indexOf('reload')==-1) {
            window.location.replace(window.location.href+'?reload');
        }else{
          $("#staffsearch").removeClass('d-none');
          $("#staffsearch").show();
          $("#loading_button").addClass('d-none');
          $("#loading_button").hide();
        }
    });

    $( ".printbutton" ).on("click", function () {
      printDiv('printableArea');
    });

   function printDiv(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(true);
    }


    $(".download-lp-search-results-staff").on("click", function () {
      var id_list = $(this).data("id-list");
      var url = ajaxdta.ajaxurl + "?action=get_lp_search_results";

      $.ajax({
        type: "POST",
        url: url,
        data: {
          id_list: id_list,
        },
        success: function (res, status, xhr) {
          var csvData = new Blob([res], { type: "text/csv;charset=utf-8;" });
          var csvURL = window.URL.createObjectURL(csvData);
          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute(
            "download",
            `learning-pathways.csv`
          );
          tempLink.click();
        },
      });
    });

    $(".add-listingto-cart-staff").on("click", function () {
      var lp_id = $(this).data("lp-id");
      var action="addstaff";
      var url = ajaxdta.ajaxurl + "?action=add_to_lpcart";
    
      $.ajax({
        type: "POST",
        url: url,
        data: {
          lp_id: lp_id, action:action
        },
        dataType:"JSON",
        success: function (data) { 
          var mString = data.count;  
          $("#stafflistingnotselected"+ lp_id).hide();
          $("#stafflistingselected"+ lp_id).show(); 
          $("#addedtocartmessage"+ lp_id).show();
          $("#addedtocartmessage"+ lp_id).text('The listing is added to your shortlist');
          $("#addedtocartmessage"+ lp_id).fadeOut(6000);           
        },
      });
    });

    $(".remove-listingfrom-cart-staff").on("click", function () {
      var lp_id = $(this).data("lp-id");
      var action="removestaff";
      var url = ajaxdta.ajaxurl + "?action=add_to_lpcart";
      
      $.ajax({
        type: "POST",
        url: url,
        data: {
          lp_id: lp_id, action:action
        },
        dataType:"JSON",
        success: function (data) { 
          var mString = data.count; 
          $("#stafflistingnotselected"+ lp_id).show();
          $("#stafflistingselected"+ lp_id).hide();
          $("#addedtocartmessage"+ lp_id).show();
          $("#addedtocartmessage"+ lp_id).text('The listing is removed from your shortlist');
          $("#addedtocartmessage"+ lp_id).fadeOut(6000);   
        },
      });
    });

    $(".add-searchto-cart-staff").on("click", function () {
      var lp_workplace_setting = $(this).data("lp-workplace-setting");
      var lp_learner_interest = $(this).data("lp-learner-interest");
      var lp_level_of_knowledge = $(this).data("lp-level-of-knowledge");
      var lp_occupation_type = $(this).data("lp-occupation-type");
      var action="savesearchstaff";

      var url = ajaxdta.ajaxurl + "?action=add_to_searchlpcart";

      $.ajax({
        type: "POST",
        url: url,
        data: {
          action:action,lp_workplace_setting: lp_workplace_setting, lp_learner_interest: lp_learner_interest, lp_level_of_knowledge:lp_level_of_knowledge, lp_occupation_type: lp_occupation_type
        },
        dataType:"JSON",
        success: function (data) { 
          var mString = data.count;
          $("#staffsavedsearch").show();
          $("#staffunsavedsearch").hide(); 
          $("#addedtocartmessagesearch").show();
          $("#addedtocartmessagesearch").text('The search is added to your shortlist');
          $("#addedtocartmessagesearch").fadeOut(6000); 
        },
      });
    });

    $(".remove-searchfrom-cart-staff").on("click", function () {
      var lp_workplace_setting = $(this).data("lp-workplace-setting");
      var lp_learner_interest = $(this).data("lp-learner-interest");
      var lp_level_of_knowledge = $(this).data("lp-level-of-knowledge");
      var lp_occupation_type = $(this).data("lp-occupation-type");
      var action="removesearchstaff";

      var url = ajaxdta.ajaxurl + "?action=add_to_searchlpcart";

      $.ajax({
        type: "POST",
        url: url,
        data: {
          action:action,lp_workplace_setting: lp_workplace_setting, lp_learner_interest: lp_learner_interest, lp_level_of_knowledge:lp_level_of_knowledge, lp_occupation_type: lp_occupation_type
        },
        dataType:"JSON",
        success: function (data) { 
          var mString = data.count;
          $("#staffunsavedsearch").show();
          $("#staffsavedsearch").hide(); 
          $("#addedtocartmessagesearch").show();
          $("#addedtocartmessagesearch").text('The search is removed from your shortlist');
          $("#addedtocartmessagesearch").fadeOut(6000); 
        },
      });
    });


    $(".addtoplan").on("click", function () {
      var lp_id = $(this).data("lp-id");
      $("#planselect"+ lp_id).show();
    });

},
};


// WEBPACK FOOTER //
// ./scripts/routes/training-plan-builder.js